import { useParams, useHistory } from 'react-router-dom';
import { useServicePackages } from './ServicePackageContext';
import { ServicePackageDetailView } from './ServicePackageDetailView';
import { Routes } from '@/utils/routes';

interface UrlParams {
  currency: string;
  packageType: string;
}

export default function ServicePackageDetailPage() {
  const { currency, packageType } = useParams<UrlParams>();
  const { packages, handleSave, handleCopyToTerm, requestClone } =
    useServicePackages();
  const history = useHistory();

  const pkg =
    packages.find(
      (p) =>
        p.currency.toLowerCase() === currency?.toLowerCase() &&
        p.package_type === packageType,
    ) ?? null;

  if (!pkg) {
    return (
      <div className="tw:p-6">
        <p className="tw:text-sm tw:text-muted-foreground">
          Package not found: {packageType} / {currency?.toUpperCase()}
        </p>
      </div>
    );
  }

  return (
    <ServicePackageDetailView
      pkg={pkg}
      onBack={() => history.push(Routes.servicePackages())}
      onSave={(term, data) => handleSave(pkg.id, term, data)}
      onCopyToTerm={handleCopyToTerm}
      onClone={() => requestClone(pkg.id)}
    />
  );
}
